import { UserRaw } from "src/app/models/interfaces/user_raw.interface"
import { RaceProgressDocumentRaw } from "./race_progress_document_raw.interface";
import { User } from "../user";

export interface RaceProgressRegistrationDataRaw {
    allDocumentsValid: boolean,
    answers: [],
    chronoTag: number,
    clUid: string,
    crew: [],
    deleted: boolean,
    deletedAuthor: string,
    deletedTimestamp: string,
    docsState: number,
    documents: RaceProgressDocumentRaw[],
    gpsTracker: string,
    info: string,
    orgComment: string,
    registrationTime: number,
    startFee: number,
    startNumber: string,
    tagReturnedAt: number,
    techComment: string,
    techMark: number,
    trackerReturnedAt: number,
    user: UserRaw,
}

export class RaceProgressRegistrationData {
    allDocumentsValid: boolean;
    answers: [];
    chronoTag: number;
    clUid: string;
    crew: [];
    deleted: boolean;
    deletedAuthor: string;
    deletedTimestamp: string;
    docsState: number;
    documents: RaceProgressDocumentRaw[];
    gpsTracker: string;
    info: string;
    orgComment: string;
    registrationTime: number;
    startFee: number;
    startNumber: string;
    tagReturnedAt: number;
    techComment: string;
    techMark: number;
    trackerReturnedAt: number;
    user: User;

    constructor(obj: RaceProgressRegistrationDataRaw) {
        this.user = new User(obj.user);
        this.allDocumentsValid = obj.allDocumentsValid;
        this.answers = obj.answers;
        this.chronoTag = obj.chronoTag;
        this.clUid = obj.clUid;
        this.crew = obj.crew;
        this.deleted = obj.deleted;
        this.deletedAuthor = obj.deletedAuthor;
        this.deletedTimestamp = obj.deletedTimestamp;
        this.docsState = obj.docsState;
        this.documents = obj.documents;
        this.gpsTracker = obj.gpsTracker;
        this.info = obj.info;
        this.orgComment = obj.orgComment;
        this.registrationTime = obj.registrationTime;
        this.startFee = obj.startFee;
        this.startNumber = obj.startNumber;
        this.tagReturnedAt = obj.tagReturnedAt;
        this.techComment = obj.techComment;
        this.techMark = obj.techMark;
        this.trackerReturnedAt = obj.trackerReturnedAt;
    }
}
